import React from "react";

const LegalWrapperComponent = () => <p>legal</p>;

export default LegalWrapperComponent;
